import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=26c6b175&scoped=true"
import script from "./classify.vue?vue&type=script&lang=ts"
export * from "./classify.vue?vue&type=script&lang=ts"
import style0 from "./classify.vue?vue&type=style&index=0&id=26c6b175&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c6b175",
  null
  
)

export default component.exports